"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CwGridSort = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwGrid = _interopRequireDefault(require("./CwGrid.scss"));

var _CwLabel = _interopRequireDefault(require("../cwlabel/CwLabel"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _CwFlexbox = _interopRequireDefault(require("../cwflexbox/CwFlexbox"));

var _CwCheckBox = _interopRequireDefault(require("../cwcheckbox/CwCheckBox"));

var _CwTable = _interopRequireDefault(require("../cwtable/CwTable"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Enums = require("../../utils/Enums");

var _CustomPropTypeValidation = require("../../utils/CustomPropTypeValidation");

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var CwGridSort = {
  ASCENDING: 'asc',
  DESCENDING: 'desc'
};
exports.CwGridSort = CwGridSort;

var CwGrid =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwGrid, _React$Component);

  function CwGrid(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwGrid);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwGrid).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectAllCheckbox", function (allIds) {
      return _react.default.createElement(_CwCheckBox.default, {
        value: _this.props.selectionColumn.selectedRows ? _this.props.selectionColumn.selectedRows.length === allIds.length : false,
        onChange: _this.props.selectionColumn.onSelectionChange ? function () {
          return _this.props.selectionColumn.onSelectionChange(_this.props.selectionColumn.selectedRows.length === allIds.length ? [] : allIds);
        } : null
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectionStyle", function () {
      var result = {};

      if (_this.props.selectionColumn.selectionColumnWidth) {
        result.width = _this.props.selectionColumn.selectionColumnWidth;
      }

      return result;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "objectsAreSame", function (x, y, skipProps) {
      var objectsAreSame = true;

      for (var propertyName in x) {
        if (skipProps.indexOf(propertyName) < 0) {
          if ((x ? !y : y) || x[propertyName] !== y[propertyName]) {
            objectsAreSame = false;
            break;
          }
        }
      }

      return objectsAreSame;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arraysEqual", function (a, b, skipProps) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length !== b.length) return false;

      for (var i = 0; i < a.length; ++i) {
        if (!_this.objectsAreSame(a[i], b[i], skipProps)) return false;
      }

      return true;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCellValue", function (source, path) {
      var result = source;

      for (var i = 0; i < path.length; i++) {
        if (result[path[i]] || result[path[i]] === 0 || result[path[i]] === '') {
          result = result[path[i]];
        } else {
          return undefined;
        }
      }

      return result;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollBarWidth", function () {
      var inner = document.createElement('p');
      inner.style.width = "100%";
      inner.style.height = "200px";
      var outer = document.createElement('div');
      outer.style.position = "absolute";
      outer.style.top = "0px";
      outer.style.left = "0px";
      outer.style.visibility = "hidden";
      outer.style.width = "200px";
      outer.style.height = "150px";
      outer.style.overflow = "hidden";
      outer.appendChild(inner);
      document.body.appendChild(outer);
      var w1 = inner.offsetWidth;
      outer.style.overflow = 'scroll';
      var w2 = inner.offsetWidth;
      if (w1 === w2) w2 = outer.clientWidth;
      document.body.removeChild(outer);
      return w1 - w2;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkIfHasScrollBar", function () {
      var node = _this.gridBody;
      var hasScrollBar = node.scrollHeight !== node.clientHeight;

      if (_this.state.hasScrollBar !== hasScrollBar) {
        _this.setState({
          hasScrollBar: hasScrollBar
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasFilterWidgets", function (columns) {
      if (columns.filter(function (column) {
        return column.filterWidget !== undefined;
      }).length > 0) {
        return true;
      }

      return false;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
      window.addEventListener("resize", _this.checkIfHasScrollBar);
      var node = _this.gridDiv;
      var rect = node.getBoundingClientRect();

      _this.setState({
        gridTop: rect.top + (_this.hasFilterWidgets(_this.props.columns) || _this.props.selectionColumn ? 64 : 32)
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function () {
      _this.checkIfHasScrollBar();
    });
    _this._prevColumns = [];
    _this.header = {};
    _this._prevValues = [];
    _this.widgetRows = [];
    _this.expandedRows = [];
    _this.state = {
      gridTop: 0,
      hasScrollBar: false
    };
    return _this;
  }
  /**
   * Checks only if the length of the array in selectedRows is the same as the allIds length
   */


  (0, _createClass2.default)(CwGrid, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.checkIfHasScrollBar);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var columns = this.props.columns.sort(function (a, b) {
        return a.order - b.order;
      });
      var allIds = this.props.value ? this.props.value.map(function (item) {
        return item.id;
      }) : [];
      var content = this.props.value ? this.props.expandable ? new Array(this.props.value.length * 2) : new Array(this.props.value.length) : undefined;

      var selectedRows = function selectedRows(rowId) {
        var index = _this2.props.selectionColumn.selectedRows.indexOf(rowId);

        var result = _this2.props.selectionColumn.selectedRows;

        if (index > -1) {
          result.splice(index, 1);
        } else {
          result.push(rowId);
        }

        return result;
      };

      if (!this.arraysEqual(this.props.columns, this._prevColumns, ['widget', 'filterWidget', 'readOnlyWidget'])) {
        this._prevColumns = this.props.columns;
        this.header = _react.default.createElement("tr", {
          className: this.props.rowHighlighting ? _CwGrid.default.headerRow : null
        }, this.props.selectionColumn ? _react.default.createElement("th", {
          style: this.selectionStyle()
        }, this.props.selectionColumn.selectionColumnLabel ? _react.default.createElement(_CwLabel.default, {
          className: _CwGrid.default.headerLabel,
          value: this.props.selectionColumn.selectionColumnLabel
        }) : this.selectAllCheckbox(allIds)) : null, columns.map(function (column) {
          return _react.default.createElement("th", {
            key: column.key,
            style: column.width ? {
              width: column.width
            } : null,
            onClick: function onClick() {
              if (column.onColumnClick) column.onColumnClick(column.key);
            }
          }, _react.default.createElement(_CwFlexbox.default, {
            align: column.alignment
          }, _react.default.createElement(_CwLabel.default, {
            className: _CwGrid.default.headerLabel,
            value: column.caption
          }), column.sorted ? _react.default.createElement(_CwImage.default, {
            className: _CwGrid.default.sortIcon,
            src: column.sorted === CwGridSort.DESCENDING ? _this2.props.descendingIcon : _this2.props.ascendingIcon
          }) : null));
        }));
      }

      if (this.props.value) {
        var gridRowId = 0;
        this.props.value.forEach(function (row, idx) {
          gridRowId += 1;
          var rowActive = _this2.props.selectionColumn && _this2.props.selectionColumn.selectedRows ? _this2.props.selectionColumn.selectedRows.indexOf(row.id) >= 0 : true;

          if (!_this2._prevValues[idx] || JSON.stringify(row) !== JSON.stringify(_this2._prevValues[idx].row) || rowActive !== _this2._prevValues[idx].rowActive) {
            _this2.widgetRows[idx] = _react.default.createElement("tr", {
              className: _this2.props.rowHighlighting ? _CwGrid.default.contentRow : null,
              onClick: _this2.props.onRowClick ? function (evt) {
                return _this2.props.onRowClick(row, evt);
              } : null,
              onDoubleClick: _this2.props.onRowDoubleClick ? function (evt) {
                return _this2.props.onRowDoubleClick(row, evt);
              } : null,
              key: row.id
            }, _this2.props.selectionColumn ? _react.default.createElement("td", {
              style: _this2.props.selectionColumn.selectionColumnWidth ? {
                width: _this2.props.selectionColumn.selectionColumnWidth
              } : null,
              className: _CwGrid.default.cellCenter
            }, _react.default.createElement(_CwCheckBox.default, {
              onChange: _this2.props.selectionColumn.onSelectionChange ? function () {
                return _this2.props.selectionColumn.onSelectionChange(selectedRows(row.id));
              } : null,
              value: rowActive
            })) : null, columns.map(function (column, idx) {
              var _ref;

              var cellClass = (0, _classnames.default)(column.wordWrap ? _CwGrid.default.wordWrap : (_ref = {}, (0, _defineProperty2.default)(_ref, _CwGrid.default.cellLeft, column.alignment === _Enums.AlignmentEnum.LEFT), (0, _defineProperty2.default)(_ref, _CwGrid.default.cellCenter, column.alignment === _Enums.AlignmentEnum.CENTER), (0, _defineProperty2.default)(_ref, _CwGrid.default.cellRight, column.alignment === _Enums.AlignmentEnum.RIGHT), _ref));
              var widgetProps = {};

              if (column.widget) {
                var _loop = function _loop(propName) {
                  if (column.widget.props.hasOwnProperty(propName) && typeof column.widget.props[propName] === "function" && propName.indexOf("on") === 0) {
                    widgetProps[propName] = function () {
                      var _column$widget$props;

                      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                      }

                      return (_column$widget$props = column.widget.props)[propName].apply(_column$widget$props, [row, column.key].concat(args));
                    };
                  }
                };

                for (var propName in column.widget.props) {
                  _loop(propName);
                }
              }

              var cellValue = _this2.getCellValue(row, column.key);

              return _react.default.createElement("td", {
                key: idx,
                style: column.width ? {
                  width: column.width
                } : null,
                className: cellClass
              }, column.widget && row.editContent || column.widget && !row.editContent && !column.readOnlyWidget ? _react.default.cloneElement(column.widget, _objectSpread({
                value: cellValue,
                row: row,
                columnKey: column.key,
                gridRowId: gridRowId,
                inAGrid: true
              }, column.widget.props, {}, widgetProps)) : !row.editContent && column.readOnlyWidget ? _react.default.cloneElement(column.readOnlyWidget, _objectSpread({
                value: cellValue,
                row: row,
                columnKey: column.key,
                gridRowId: gridRowId,
                inAGrid: true
              }, column.readOnlyWidget.props, {}, widgetProps)) : Object.prototype.toString.call(cellValue) === '[object String]' ? _react.default.createElement(_CwLabel.default, {
                value: cellValue
              }) : cellValue);
            }));
          }

          content.push(_this2.widgetRows[idx]);

          if (_this2.props.expandable && (!_this2._prevValues[idx] || JSON.stringify(row) !== JSON.stringify(_this2._prevValues[idx].row))) {
            _this2.expandedRows[idx] = _react.default.createElement("tr", {
              key: row.id + 'e',
              style: row.expandedRow ? null : {
                display: 'none'
              }
            }, _react.default.createElement("td", {
              colSpan: _this2.props.selectionColumn ? columns.length + 1 : columns.length
            }, row.expandedRow ? row.expandedRowContent : null));
          }

          content.push(_this2.expandedRows[idx]);
          _this2._prevValues[idx] = {
            row: row,
            rowActive: rowActive
          };
        });
      }

      var bodyStyle = {};
      bodyStyle = this.props.scrollBodyHeight === -1 ? {
        overflow: 'auto',
        height: 'calc(100vh - ' + (this.state.gridTop + 48) + 'px)'
      } : {
        overflow: 'auto',
        height: this.props.scrollBodyHeight
      };
      return _react.default.createElement("div", {
        ref: function ref(div) {
          return _this2.gridDiv = div;
        }
      }, _react.default.createElement("div", {
        style: this.state.hasScrollBar ? {
          paddingRight: this.getScrollBarWidth()
        } : {}
      }, _react.default.createElement(_CwTable.default, {
        nested: this.props.nested,
        alternatingRowColors: this.props.alternatingRowColors
      }, _react.default.createElement("thead", null, this.header, this.hasFilterWidgets(columns) || this.props.selectionColumn ? _react.default.createElement("tr", {
        className: _CwGrid.default.headerRowSecond
      }, this.props.selectionColumn && this.props.selectionColumn.selectionColumnLabel ? _react.default.createElement("th", null, this.selectAllCheckbox(allIds)) : this.props.selectionColumn && !this.props.selectionColumn.selectionColumnLabel ? _react.default.createElement("th", null) : null, columns.map(function (column) {
        return column.filterWidget ? _react.default.createElement("th", {
          key: column.key
        }, column.filterWidget) : _react.default.createElement("th", {
          key: column.key
        });
      })) : null))), _react.default.createElement("div", {
        ref: function ref(div) {
          return _this2.gridBody = div;
        },
        style: bodyStyle
      }, _react.default.createElement(_CwTable.default, {
        nested: this.props.nested,
        alternatingRowColors: this.props.alternatingRowColors
      }, _react.default.createElement("tbody", {
        className: this.props.expandable && this.props.alternatingRowColors ? _CwGrid.default.gridBodyExpandable : _CwGrid.default.gridBody
      }, content))));
    }
  }]);
  return CwGrid;
}(_react.default.Component);

;
CwGrid.propTypes = {
  /**
   * Array of data for the grid. Id is required for each item.
   */
  value: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,

    /**
     * If the grid's prop expandable is set to true this prop can be used for showing or hiding the expanded row
     */
    expandedRow: _propTypes.default.bool,

    /**
     * If the grid's prop expandable is set to true this prop can be used to define the expanded row's content
     */
    expandedRowContent: _propTypes.default.node,

    /**
     * This prop can be used for swiching the row from readOnly to edit mode
     */
    editContent: _propTypes.default.bool
  })),

  /**
   * Array of objects that define the columns.
   */
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * corresponds to the field from "value" that will be displayed in the column
     */
    key: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

    /**
     * the column's label displayed in the header
     */
    caption: _propTypes.default.string,

    /**
     * Define a component to be used as a template for the column cells.
     * The component's props that start with "on" and are functions will be intercepted and passed the whole row as an argument
     * The component must have 'value' propType.
     */
    widget: (0, _CustomPropTypeValidation.componentHasPropTypes)(['value']),

    /**
     * Define a component to be used as a template for the column cells in readOnly mode.
     * The component must have 'value' propType.
     */
    readOnlyWidget: (0, _CustomPropTypeValidation.componentHasPropTypes)(['value']),

    /**
     * option to provide fix width
     */
    width: _propTypes.default.number,

    /**
     * alignment of header and cell content
     */
    alignment: _propTypes.default.oneOf([_Enums.AlignmentEnum.LEFT, _Enums.AlignmentEnum.CENTER, _Enums.AlignmentEnum.RIGHT]),

    /**
     * number used for ordering the columns
     */
    order: _propTypes.default.number,

    /**
     * if set the corresponding icon will be displayed next to the label
     */
    sorted: _propTypes.default.oneOf([CwGridSort.ASCENDING, CwGridSort.DESCENDING]),

    /**
     * Callback function to be called on column header click
     */
    onColumnClick: _propTypes.default.func,

    /**
     * Sets whether the cell is allowed to wordwrap
     */
    wordWrap: _propTypes.default.bool,

    /**
     * Filters the column with the value from the widget
     */
    filterWidget: _propTypes.default.element
  })).isRequired,

  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Path to ascending order icon
   */
  ascendingIcon: _propTypes.default.string,

  /**
   * Path to descending order  icon
   */
  descendingIcon: _propTypes.default.string,

  /**
   * Set whether to highlight row on mouse hover
   */
  rowHighlighting: _propTypes.default.bool,

  /**
   * Indicates that the grid should have checkboxes for each row
   */
  selectionColumn: _propTypes.default.shape({
    /**
     * An optional label to be shown above checkbox column
     */
    selectionColumnLabel: _propTypes.default.string,

    /**
     * Array of indexes coresponding to the id field of the records
     * that should have their checkboxes selected
     */
    selectedRows: _propTypes.default.arrayOf(_propTypes.default.number),

    /**
     * A callback function that will be called when a checkbox is clicked,
     * it will pass an array with the ids of all selected records
     */
    onSelectionChange: _propTypes.default.func,

    /**
     * option to provide fix width
     */
    selectionColumnWidth: _propTypes.default.number
  }),

  /**
   * create extra rows that can be expanded
   */
  expandable: _propTypes.default.bool,

  /**
   * Func fired when a row is clicked
   * @param {row} row - the row clicked
   * @param {event} [evt] - the click event
   */
  onRowClick: _propTypes.default.func,

  /**
   * Func fired when a row is double clicked
   * @param {row} row - the row double clicked
   * @param {event} [evt] - the double click event
   */
  onRowDoubleClick: _propTypes.default.func,

  /**
   * Set to false if alternating row colors are not desired
   */
  alternatingRowColors: _propTypes.default.bool,

  /**
   * Whether the grid is a nested grid and requires different styles.
   */
  nested: _propTypes.default.bool,

  /**
   * Make grid body scrollable and set to a specific height (set to -1 to extend to bottom of window)
   */
  scrollBodyHeight: _propTypes.default.number
};
CwGrid.defaultProps = {
  rowHighlighting: true,
  alternatingRowColors: true,
  ascendingIcon: _IconPath.default.get('Action_CollapseUp'),
  descendingIcon: _IconPath.default.get('Action_ExpandDown')
};
var _default = CwGrid;
exports.default = _default;